export const HOT_LEAGUES = [
  {
    id: 1639,
    name: 'Ngoại hạng Anh',
    slug: 'ngoai-hang-anh',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Premier-League.webp',
    type: 1
  },
  {
    id: 1134,
    name: 'La Liga',
    slug: 'la-liga',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Spanish-La-Liga.webp',
    type: 1
  },
  {
    id: 1437,
    name: 'Serie A',
    slug: 'seri-a',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Italian-Serie-A.webp',
    type: 1
  },
  {
    id: 188,
    name: 'Bundesliga',
    slug: 'bundesliga',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/German-Bundesliga.webp',
    type: 1
  },
  {
    id: 1112,
    name: 'Ligue 1',
    slug: 'ligue-1',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/France-Ligue-1.webp',
    type: 1
  },
  {
    id: 13014,
    name: 'Cúp C1 Châu Âu',
    slug: 'cup-c1-chau-au',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/UEFA-Champions-League.webp',
    type: 2
  },
  {
    id: 13115,
    name: 'Cup C2 Châu Âu',
    slug: 'cup-c2-chau-au',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
    type: 2
  },
  {
    id: 16679,
    name: 'V-League',
    slug: 'v-league',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
    type: 1
  }
];

export const TAB_LABELS = {
  'totalStandings': 'Tổng quan',
  'homeStandings': 'Sân nhà',
  'awayStandings': 'Sân khách',
  'halfStandings': 'Hiệp 1',
  'homeHalfStandings': 'Sân nhà (Hiệp 1)',
  'awayHalfStandings': 'Sân khách (Hiệp 1)',
  'group_a': 'Bảng A',
  'group_b': 'Bảng B',
  'group_c': 'Bảng C',
  'group_d': 'Bảng D',
  'group_e': 'Bảng E',
  'group_f': 'Bảng F',
  'group_g': 'Bảng G',
  'group_h': 'Bảng H'
};

export const API_ENDPOINTS = {
  LEAGUES_HOT: '/api/leagues/hot',
  LEAGUES_ALL: '/api/leagues',
  RANKINGS: '/api/rankings'
};
